import { createFileRoute } from "@tanstack/react-router";
import { Shell } from "@/components/control-tower/Layout";
import { PerspectiveHero } from "@/components/control-tower/PerspectiveHero";
import { EquipmentPerformanceSection } from "@/components/control-tower/perspectives/EquipmentPerformanceSection";

export const Route = createFileRoute("/equipment-performance")({
  component: AnalysisPage,
});

// Talotekniikan toimivuus perspective — judgment lens only, same IA as Datan laatu /
// Sisäilmaolosuhteet: building scope is the live workspace, no Yhteenveto/Havainnot/
// Tapahtumaloki topic tabs. The Trendi signal explorer and the
// Kiinteistöraportti (Älyanalyysi / Smart Report) surface each live in their own Toiminto
// (/trend, /reports), never embedded here.
function AnalysisPage() {
  return (
    <Shell
      title="Talotekniikan toimivuus"
      subtitle="Käyttäytymisen tila ja havainnot"
    >
      <div className="space-y-6">
        <PerspectiveHero perspectiveId="equipment-performance" />
        <EquipmentPerformanceSection />
      </div>
    </Shell>
  );
}
